var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:(_vm.styles),attrs:{"role":"progressbar","aria-valuenow":"value","aria-valuemin":"0","aria-valuemax":"100"}},[_vm._v("\n        "+_vm._s(_vm.value)+"%\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }